import { z } from 'zod'

import { promoSchema } from './promo'
import { prospectSchema } from './prospect'
import { listQueryZodFields, dbEntitySchema } from './system'
import { userSchema } from './user'

const promoUseBaseSchema = dbEntitySchema.extend({
  promo: z.string(),
  user: z.string().nullish(),
  prospect: z.string().nullish(),
  expiredCredit: z.boolean().default(false),
})

export const promoUseSchema = promoUseBaseSchema.refine(
  (value) => Boolean(value.user || value.prospect),
  {
    message: 'PromoUse requires a user or prospect',
    path: ['user'],
  }
)

export const promoUseUserRefSchema = userSchema.pick({
  id: true,
  firstName: true,
  lastName: true,
  email: true,
})

export const promoUsePromoRefSchema = promoSchema.pick({
  id: true,
  code: true,
})

export const promoUseProspectRefSchema = prospectSchema.pick({
  id: true,
  firstName: true,
  lastName: true,
  email: true,
})

export const promoUseWithDataSchema = promoUseBaseSchema
  .extend({
    promo: z.union([z.string(), promoUsePromoRefSchema]),
    user: z.union([z.string(), promoUseUserRefSchema]).nullish(),
    prospect: z.union([z.string(), promoUseProspectRefSchema]).nullish(),
  })
  .refine((value) => Boolean(value.user || value.prospect), {
    message: 'PromoUse requires a user or prospect',
    path: ['user'],
  })

export const promoUseListQuerySchema = z.object({
  ...listQueryZodFields,
  promoId: z.string().nullish(),
  userId: z.string().nullish(),
  prospectId: z.string().nullish(),
  expiredCredit: z.coerce.boolean().optional().nullable(),
})

export const promoUsesListResponseSchema = z.object({
  data: z.array(promoUseWithDataSchema),
})
